import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

const formatRate = (rate) => {
  // 빈 값("", null, undefined)일 때 "%"만 덩그러니 보이던 버그 수정.
  // 모든 화면 크기에 적용.
  if (rate === null || rate === undefined || rate === '') {
    return '-';
  }
  return `${rate}%`;
};

const summaryItems = (chance) => [
  { label: '매출처', value: chance?.vendorCmpNm || '-' },
  { label: '고객사', value: chance?.customerNm || '-' },
  { label: '매출(수금)예정일', value: chance?.expDay || '-' },
  {
    label: '매출액',
    value: chance?.expSales
      ? `${Number(chance.expSales).toLocaleString()}원`
      : '-',
  },
  {
    label: '매출 이익',
    value: chance?.totalProfit
      ? `${Number(chance.totalProfit).toLocaleString()}원`
      : '-',
  },
  { label: '예상 이익률', value: formatRate(chance?.expBenefitRate) },
];

const ChanceStepDescInfo = ({ chance }) => {
  const items = summaryItems(chance);

  return (
    <Paper
      sx={{
        my: 0,
        p: 0,
        // sm+: 더 이상 독립 카드가 아니다 — 데스크톱 압축 헤더 카드(ChanceStepperContainer)의
        // Row 2(요약 스트립)로 들어가므로 테두리/배경 없이 투명한 래퍼로만 쓴다.
        border: { xs: '1px solid', sm: 'none' },
        borderColor: 'divider',
        borderRadius: { xs: 1, sm: 0 },
        backgroundColor: { xs: 'background.paper', sm: 'transparent' },
      }}
      variant="outlined"
    >
      {/* xs: 2열 key/value 그리드 (6개 항목 = 3행), 가로 스크롤 없음 */}
      <Box
        sx={{
          display: { xs: 'grid', sm: 'none' },
          gridTemplateColumns: '1fr 1fr',
          columnGap: 1.5,
          rowGap: 0.75,
          px: 1,
          py: 0.75,
        }}
      >
        {items.map((item) => (
          <Box key={item.label} sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              component="div"
              color="text.secondary"
              sx={{ fontSize: '10px', lineHeight: 1.2 }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body2"
              component="div"
              sx={{
                fontWeight: 'medium',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* sm+: 압축 인라인 요약 스트립 (label·value 쌍을 한 줄로, 좁아지면 2줄로 줄바꿈).
          데스크톱 압축 헤더 카드 안에 Row 2로 들어간다 — 별도 카드/구분선 없음. */}
      <Box
        sx={{
          display: { xs: 'none', sm: 'flex' },
          flexWrap: 'wrap',
          rowGap: 0.5,
          columnGap: 3,
        }}
      >
        {items.map((item) => (
          <Box
            key={item.label}
            sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, minWidth: 0 }}
          >
            <Typography
              variant="caption"
              component="span"
              color="text.secondary"
              sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body2"
              component="span"
              sx={{ fontWeight: 'medium', whiteSpace: 'nowrap' }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default ChanceStepDescInfo;
